import AdminProfileMenu from './AdminProfileMenu';

/* The one admin top bar.
   ---------------------------------------------------------------------------
   There were eight of these before — five different heights, three z-indexes,
   two border colours, some with a shadow. Then four pages also dropped a search
   box into it while twenty-one did not, and the two brand dashboards used
   different placeholder text, so the bar still changed as you navigated.

   It takes no slots now: breadcrumb, then the profile menu. Page controls go in
   the page header (AdminLayout's `actions`) and search goes above the list it
   filters (`.ax-search`), which is where the bar can't drift from page to page.
   Styling lives in styles/adminShell.css (`.ax-topbar`).

   The breadcrumb is inset below the xl breakpoint to clear the sidebar's
   floating hamburger button. */

export interface AdminTopbarProps {
  /** Breadcrumb parent — the sidebar section this page sits under. */
  section?: string;
  /** Breadcrumb leaf — the current page. */
  title: string;
}

export default function AdminTopbar({ section, title }: AdminTopbarProps) {
  return (
    <header className="ax-topbar">
      <span className="ax-crumb">
        {section && (<>{section}<span className="ax-crumb-sep">/</span></>)}
        <b>{title}</b>
      </span>
      <AdminProfileMenu />
    </header>
  );
}
